export default {
  procedure_1: [
    {
      id: 1,
      name: "FORMATO: POLÍTICA",
      code: "FOR-P1-01",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
  ],
  procedure_2: [
    {
      id: 1,
      name: "FORMATO: IDENTIFICACIÓN DE ASPECTOS AMBIENTALES Y EVALUACIÓN DE IMPACTOS AMBIENTALES",
      code: "FOR-SAES-XXX-001",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
  ],
  procedure_3: [
    {
      id: 1,
      name: "FORMATO: REQUISITOS LEGALES Y OTROS APLICABLES",
      code: "FOR-SAES-XXX-03",
      cloud: false,
      fileDownload: false,
      createFiles: false,
    },
  ],
  procedure_4: [
    {
      id: 1,
      name: "FORMATO: DISEÑO Y ESTABLECIMIENTO DE OBJETIVOS, METAS E INDICADORES",
      code: "FOR-P4-01",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
  ],
  procedure_5: [
    {
      id: 1,
      name: "FORMATO: ORGANIGRAMA",
      code: "FOR-P5-01",
      cloud: false,
      fileDownload: true,
      createFiles: false,
    },
    {
      id: 2,
      name: "FORMATO: DESIGNACIÓN DEL REPRESENTANTE TÉCNICO",
      code: "FOR-P5-02",
      fileDownload: false,
      completed: true,
      createFiles: true,
    },
    {
      id: 3,
      name: "FORMATO: SOLICITUD DE RECURSOS",
      code: "FOR-P5-03",
      completed: true,
      createFiles: true,
    },
  ],
  procedure_6: [
    {
      id: 1,
      name: "FORMATO: PERFIL DEL PUESTO",
      code: "FOR-P6-01",
      completed: true,
      createFiles: true,
    },
    {
      id: 2,
      name: "FORMATO: LISTA DE VERIFICACIÓN PARA DETECCIÓN DE NECESIDADES DE CAPACITACIÓN",
      code: "FOR-P6-02",
      completed: true,
      createFiles: true,
    },
    {
      id: 3,
      name: "FORMATO: PROGRAMA DE INDUCCIÓN, CAPACITACIÓN Y ENTRENAMIENTO.",
      code: "FOR-P6-03",
      completed: true,
      createFiles: true,
    },
    {
      id: 4,
      name: "FORMATO: EVALUACIÓN DE LA CAPACITACIÓN Y/O ENTRENAMIENTO",
      code: "FOR-P6-04",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 5,
      name: "FORMATO: REGISTRO DE COMPETENCIAS",
      code: "FOR-P6-05",
      completed: true,
      createFiles: true,
    },
  ],
  procedure_7: [
    {
      id: 1,
      name: "FORMATO: MATRIZ DE COMUNICACIÓN",
      code: "FOR-P7-01",
      type: "cloud",
      completed: true,
      createFiles: true,
    },
    {
      id: 2,
      name: "FORMATO: ACTOS Y CONDICIONES INSEGURAS DE TRABAJO Y/O QUE PUEDEN DAÑAR EL MEDIO AMBIENTE",
      code: "FOR-P7-02",
      type: "implementation",
      fileDownload: false,
      completed: true,
      createFiles: true,
    },
    {
      id: 3,
      name: "FORMATO: REGISTRO DE SOLICITUDES, NECESIDADES DE INFORMACIÓN, QUEJAS O SUGERENCIAS",
      code: "FOR-P7-03",
      fileDownload: false,
      completed: true,
      createFiles: true,
    },
    {
      id: 4,
      name: "FORMATO: SEGUIMIENTO DE ATENCIÓN",
      code: "FOR-P7-04",
      completed: true,
      createFiles: true,
    },
    {
      id: 5,
      name: "FORMATO: LISTA DE ASISTENCIA Y COMUNICACIÓN DE INFORMACIÓN",
      code: "FOR-P7-05",
      fileDownload: false,
      completed: true,
      createFiles: true,
    },
  ],
  procedure_8: [
    {
      id: 1,
      name: "FORMATO: CREACIÓN O MODIFICACIÓN",
      code: "FOR-P8-01",
      type: "cloud",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 2,
      name: "FORMATO: LISTA MAESTRA",
      code: "FOR-P8-02",
      type: "implementation",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 3,
      name: "FORMATO: CARTA DE CONFIDENCIALIDAD",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P8-03",
    },
    {
      id: 4,
      name: "FORMATO: CONTROL DE DOCUMENTOS EXTERNOS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P8-04",
    },
  ],
  procedure_9: [
    {
      id: 1,
      name: "FORMATO: IDENTIFICACIÓN DE MEJORES PRÁCTICAS Y ESTÁNDARES",
      code: "FOR-P9-01",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
  ],
  procedure_10: [
    {
      id: 1,
      name: "FORMATO: CONTROLES OPERACIONALES",
      code: "FOR-P10-01",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
  ],
  procedure_11: [
    {
      id: 1,
      name: "FORMATO: PROGRAMA ANUAL DE MANTENIMIENTO",
      code: "FOR-P11-01",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 2,
      name: "FORMATO: EQUIPOS CRÍTICOS",
      code: "FOR-P11-02",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 3,
      name: "FORMATO: CONTROL DE REGISTROS Y CAMBIOS",
      code: "FOR-P11-03",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
  ],
  procedure_12: [
    {
      id: 1,
      name: "FORMATO: CARTA RESPONSIVA",
      code: "FOR-P12-01",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 2,
      name: "FORMATO: REQUISITOS DEL SASISOPA PARA CONTRATISTAS, SUBCONTRATISTAS, PRESTADORES DE SERVICIO Y PROVEDORES",
      code: "FOR-P12-02",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 3,
      name: "FORMATO: CONTRATISTAS APROBADOS",
      code: "FOR-P12-03",
      cloud: false,
      fileDownload: false,
      createFiles: true,
    },
    {
      id: 4,
      name: "FORMATO: PERMISOS DE TRABAJO DE ALTO RIESGO",
      code: "FOR-P12-04",
      cloud: false,
      fileDownload: false,
      createFiles: false,
    },
  ],
  procedure_13: [
    {
      id: 1,
      name: "FORMATO: PLAN DE ATENCIÓN A EMERGENCIAS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P13-01",
    },
    {
      id: 2,
      name: "FORMATO: DISPONIBILIDAD DE RECURSOS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P13-02",
    },
    {
      id: 3,
      name: "FORMATO: CONFORMACIÓN DE BRIGADAS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P13-03",
    },
    {
      id: 4,
      name: "FORMATO: NÚMEROS DE EMERGENCIA",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P13-04",
    },
  ],
  procedure_14: [
    {
      id: 2,
      name: "FORMATO: GESTIÓN DE HALLAZGOS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P14-02",
    },
  ],
  procedure_15: [
    {
      id: 1,
      name: "FORMATO: PROGRAMA DE AUDITORÍAS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P15-01",
    },
    {
      id: 2,
      name: "FORMATO: PLAN DE AUDITORÍA",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P15-02",
    },
    {
      id: 3,
      name: "FORMATO: INFORME DE AUDITORÍA",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P15-03",
    },
  ],
  procedure_16: [
    {
      id: 1,
      name: "PROGRAMA DE ACTIVIDADES DE INVESTIGACIONES CAUSA RAÍZ",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P16-01",
    },
  ],
  procedure_17: [
    {
      id: 1,
      name: "FORMATO: REVISIÓN DE RESULTADOS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P17-01",
    },
    {
      id: 2,
      name: "FORMATO: INFORME DE RESULTADOS",
      cloud: false,
      fileDownload: false,
      createFiles: true,
      code: "FOR-P17-02",
    },
  ],
  procedure_18: [],
};
